/**
 * JSON Protocol Parser
 *
 * Default protocol parser - handles plain JSON messages.
 */

import type { IProtocolParser, ParsedMessage } from '../types';

export class JsonProtocolParser implements IProtocolParser {
  readonly name = 'json';

  canParse(raw: string | ArrayBuffer): boolean {
    try {
      const text = typeof raw === 'string' ? raw : new TextDecoder().decode(new Uint8Array(raw));
      const trimmed = text.trim();
      return trimmed.startsWith('{') || trimmed.startsWith('[');
    } catch {
      return false;
    }
  }

  parse(raw: string | ArrayBuffer): ParsedMessage {
    try {
      const text = typeof raw === 'string' ? raw : new TextDecoder().decode(new Uint8Array(raw));
      const body = JSON.parse(text);
      return { body, format: 'json' };
    } catch (error) {
      return {
        body: null,
        format: 'json',
        error: `JSON parse error: ${error instanceof Error ? error.message : String(error)}`,
      };
    }
  }

  serialize(body: unknown): string {
    return JSON.stringify(body);
  }
}
